import React from "react";
import { useUserApi } from "../../../../services/UserApi";
import Button from "carbon-react/lib/components/button";

const RegenerateMfaRecoveryCode = (props) => {
  const { regenerateMfaRecoveryCode } = useUserApi();

  const regenerateMfaRecoveryCodeCommentsDialogState = {
    captureLanguage: true,
    title: `Regenerate MFA recovery code`,
    userHeading: `${props.user.name} (${props.user.email})`,
    subTitle:
      "Regenerating the user's MFA Recovery Code will invalidate their existing code. Are you sure you want to continue?",
    promptCaption: "Confirm",
    prompts: [
      "Before proceeding, please ensure that you have positively verified that the person requesting this action is the owner of the account.",
    ],
    buttonCaption: "Confirm",
    performAction: async (params) => {
      const result = await regenerateMfaRecoveryCode(
        props.user.userId,
        params?.languageCode,
        params?.agentComments
      );

      if (!result.success)
        throw new Error(
          result.error?.description || "Failed to regenerate MFA Recovery Code"
        );
    },
    successToast: `MFA recovery code regenerated for '${props.user.email}'.`,
  };

  return (
    <div>
      <Button
        as="primary"
        onClick={() => {
          props.openCommentsDialog(
            regenerateMfaRecoveryCodeCommentsDialogState
          );
        }}
        className="regenerateMfaRecoveryCodeButton"
      >
        Regenerate MFA recovery code
      </Button>
    </div>
  );
};

export default RegenerateMfaRecoveryCode;
